import { Component, OnInit } from "@angular/core";
import { DataService_SSO } from "../shared/data.service";
import { DialogService } from "primeng/dynamicdialog";
import { ConfirmationService } from "primeng/api";
import { ModifyIDPComponent } from "./modify-idp/modify-idp.component";

@Component({
	selector: "caass-identity-provider-table",
	templateUrl: "./identity-provider-table.component.html",
	styleUrls: ["./identity-provider-table.component.css"],
})
export class IdentityProviderTableComponent implements OnInit {
	constructor(private dataService: DataService_SSO, private dialogService: DialogService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.loadTable();
	}

	//////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////

	pagerows: any = 10;
	pagefirst: any = 0;

	SelectedIdentityProvider: any;
	lstIdentityProvider: any = [];

	lstActiveDesc: any = [];

	TableLoading: boolean = false;
	Processing: boolean = false;

	errorMessage: string = "";

	ToggleText: string = "Deactivate IDP";

	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////

	loadTable() {
		this.errorMessage = "";
		this.onRowUnselect(null);

		this.TableLoading = true;

		var result = this.dataService.IdentityProviderSelectList();
		result.subscribe(
			(response) => {
				this.lstIdentityProvider = response;

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstIdentityProvider.map((item: any) => item.ActiveDesc))).sort();

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////

	onRefresh() {
		this.loadTable();
	}

	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(ModifyIDPComponent, {
			header: "Add IDP",
			width: "fit-content",
			data: {
				EditMode: false,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTable();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedIdentityProvider == undefined) {
			this.errorMessage = "Select an IDP to edit";
			return;
		}

		var ref = this.dialogService.open(ModifyIDPComponent, {
			header: "Edit IDP",
			width: "fit-content",
			data: {
				EditMode: true,
				IdentityProviderID: this.SelectedIdentityProvider.IdentityProviderID,
				IdentityProviderCD: this.SelectedIdentityProvider.IdentityProviderCD,
				IdentityProviderDesc: this.SelectedIdentityProvider.IdentityProviderDesc,
				LoginButtonDesc: this.SelectedIdentityProvider.LoginButtonDesc,
				LoginButtonBackground: this.SelectedIdentityProvider.LoginButtonBackground,
				LoginButtonForeground: this.SelectedIdentityProvider.LoginButtonForeground,
				LoginButtonIconLink: this.SelectedIdentityProvider.LoginButtonIconLink,
				LoginButtonLink: this.SelectedIdentityProvider.LoginButtonLink,
				LogoutButtonLink: this.SelectedIdentityProvider.LogoutButtonLink,
				ZOrder: this.SelectedIdentityProvider.ZOrder,
				Active: this.SelectedIdentityProvider.Active,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTable();
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		if (this.SelectedIdentityProvider == undefined) {
			this.errorMessage = "Select an IDP to deactivate";
			return;
		}

		this.Processing = true;

		var result = this.dataService.IdentityProviderToggle(
			this.SelectedIdentityProvider.IdentityProviderID,
			this.SelectedIdentityProvider.Active == true ? 0 : 1
		);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.loadTable();
				} else {
					this.confirmationService.confirm({
						key: "idpmain",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not toggle IDP: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDelete() {
		this.errorMessage = "";

		if (this.SelectedIdentityProvider == undefined) {
			this.errorMessage = "Select an IDP to delete";
			return;
		}

		this.confirmationService.confirm({
			key: "idpmainconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				"Are you sure you want to delete the " +
				this.SelectedIdentityProvider.IdentityProviderDesc +
				" IDP? It will no longer show up on the Login screen and you will have to re-enter the config settings if you want to add it back. NOTE: You can also deactivate IDPs to keep them from showing on the login page.",
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.onFinishDelete();
			},
		});
	}

	onFinishDelete() {
		this.Processing = true;

		var result = this.dataService.IdentityProviderDelete(this.SelectedIdentityProvider.IdentityProviderID);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.loadTable();
				} else {
					this.confirmationService.confirm({
						key: "idpmain",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete IDP: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////

	onRowDblClick(val) {
		this.errorMessage = "";

		this.SelectedIdentityProvider = val;

		this.onEdit();
	}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedIdentityProvider = val.data;

		this.ToggleText = "Deactivate IDP";
		if (this.SelectedIdentityProvider.Active == false) {
			this.ToggleText = "Activate IDP";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedIdentityProvider = null;
		this.ToggleText = "Deactivate IDP";
	}

	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}

	//////////////////////////////////////////////////////
}
